<template>
  <div class="cmp-product-list-item utlz-col-sm-4" :class="'utlz-col-lg-' + blockSize">
    <div class="utlz-row utlz-no-gutters utlz-gutters-sm item-wrapper">
      <template v-if="product.prices != 'undefined'">
        <span v-if="isSalesAction" v-translation="{ type: 'label', code: 'label_sales_action' }" class="action-banner"></span>
      </template>
      <div class="utlz-col-3 utlz-col-sm-12 img-container">

          <utlz-favorites-control v-if="showFavorites" :product="product"></utlz-favorites-control>

          <figure class="img-square prod-img">
            <a :href="product.targetUrl" class="clickthrough" :class="imageRatioClass">
              <img :ref="'productImage'" class="img-fluid" :alt="product.imageAltText" :title="product.imageTitleText" :src="product.imageUrl ? product.imageUrl : '/documents/productimages/not-available-large.jpg'" />
            </a>
          </figure>
      </div>

      <div class="utlz-col-9 utlz-col-sm-12 text-container">
        <a :href="product.targetUrl" class="clickthrough">
          <!-- BESPOKE RUT-21: Disabled product code -->
          <!-- <div class="product-code">
            <span class="value">{{ product.id }}</span>
          </div> -->
          <!-- END BESPOKE RUT-21 -->
          <!-- BESPOKE RUT-20: Changed product.shortDescription to productTitle -->
          <h2 class="prod-title header-small header-normal-sm">{{ productTitle }}</h2>
          <!-- END BESPOKE RUT-20 -->

          <p class="prod-desc2">
            {{ product.customStrings.PROD_DESC2}}
          </p>
        </a>

        <!-- BESPOKE RUT-20: 
            > Added && product.productVariants.length === 1 to only show prices if product is not part of a product grouping 
            > Added :productVatPercentage -->
        <div class="ph-product-price" v-if="product.prices.length && product.productVariants.length === 1 && (product.variantKey === '' || product.variantKey === null || product.variantKey === undefined)">
          <utlz-product-price
            :prices="product.prices[0]"
            :parentClassRef="'ref-product-list-item'"
            :productVatPercentage="product.customDecimals.VAT_PERCENTAGE"
          ></utlz-product-price>
        </div>
        <template v-else>
          <div class="ph-product-price"></div>
        </template>
        <!-- END BESPOKE RUT-20 -->

        <!-- BESPOKE RUT-20: Disabled product variants -->
        <!-- <utlz-product-variant
          v-if="product.variantKey && groupProductsList != 0 && showOrderProductControl"
          :product="computedProduct"
          :productVariants="product.productVariants"
          @selectedProduct="selectedProduct($event)"
        ></utlz-product-variant> -->
        <!-- END BESPOKE RUT-20 -->

        <div class="ph-order-product">
          <transition name="fade">
            <!-- BESPOKE GOOL-2: Show button to click through to product details instead of order product -->
            <a :href="product.targetUrl" class="order-button button theme-primary">
              <i class="uws-icon uws-cart" aria-hidden="true"></i>
              <span class="" v-translation="{ code: 'button_order', type: 'button' }"></span>
            </a>
            <!-- END BESPOKE GOOL-2 -->
            <!-- <utlz-order-product
              v-if="showOrderProductControl && product.prices.length"
              :product="computedProduct"
              :parentClassRef="'ref-product-list-item'"
            >
            </utlz-order-product> -->
          </transition>

          <transition name="fade">
            <p v-if="showOutOfStockMessage && showStock" class="out-of-stock-msg">
              <i class="fa fa-warning"></i>
              <span v-translation="{ type: 'label', code: 'label_out_of_stock' }"></span>
            </p>
          </transition>
        </div>

        <!-- BESPOKE RUT: Disable stock indicators in elastic product list -->
        <!-- If product has variants, disable stock and
        use stock in OrderProduct.vue component which is variant specific -->
        <!-- <utlz-product-stock
          v-if="!product.variantKey || groupProductsList == 0"
          :stock="product.stock"
          :stockTotal="product.stock"
        ></utlz-product-stock> -->
        <!-- END BESPOKE RUT -->

      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Product } from 'src/models/product.model';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import ProductVariant from 'src/components/webshop/products/product-variant/ProductVariant.vue';
import FavoritesControl from 'src/components/webshop/favorites/FavoritesControl.vue';
export default {
  components: {
    'utlz-product-price': ProductPrice,
    'utlz-product-stock': ProductStock,
    'utlz-order-product': OrderProduct,
    'utlz-product-variant': ProductVariant,
    'utlz-favorites-control': FavoritesControl
  },
  props: {
    product: { type: Product, required: true },
    blockSize: { type: Number, required: false, default: 3 }
  },
  data () {
    return {
      isSalesAction: this.product.prices[0],
      activeProductVariantId: null,
      imageRatioClass: ''
    };
  },
  computed: {
    // BESPOKE RUT
    // Added getters.language 
    ...mapGetters(['showStock', 'showPrices', 'showFavorites', 'showOrderProduct', 'stockLimit', 'groupProductsList', 'language']),
    // END BESPOKE RUT-20

    // BESPOKE RUT-20    
    // Display grp name as product title if available
    productTitle () {
      let title = this.product.customStrings["GroupDescription_" + this.language];
      if (title !== undefined) {
        return title;
      } else {
        return this.product.shortDescription;
      }
      
    },
    // END BESPOKE RUT-20
    showOrderProductControl () {
      if (!this.showPrices) {
        return false;
      } else if (this.showOrderProduct) {
        if (!this.stockLimit) {
          return true;
        } else if (this.stockLimit && this.product.stock !== null) {
          return this.stockLimit && this.product.stock.stockTotal > 0;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showOutOfStockMessage () {
      if (!this.stockLimit) {
        return false;
      } else if (this.product.stock !== null && this.showOrderProduct) {
        return this.product.stock.stockTotal <= 0;
      } else {
        return false;
      }
    },
    computedProduct () {
      if (!this.product.variantKey) {
        return this.product;
      } else {
        if (this.activeProductVariantId) {
          const index = this.product.productVariants.findIndex(product => {
            return product.id === this.activeProductVariantId;
          });
          return this.product.productVariants[index];
        } else {
          return this.product;
        }
      }
    }
  },
  mounted () {
    this.$refs.productImage.onload = () => {
      let ratioClass = 'square';
      const width = window.$(this.$refs['productImage']).context.naturalWidth;
      const height = window.$(this.$refs['productImage']).context.naturalHeight;
      const ratio = width / height;
      if (ratio < 1) {
        ratioClass = 'portrait';
      } else if (ratio > 1) {
        ratioClass = 'landscape';
      }
      this.imageRatioClass = ratioClass;
    }
  },
  methods: {
    selectedProduct (id) {
      this.activeProductVariantId = id;
    }
  }
};
</script>

<style>
</style>
